<template>
    <div class="pa-5 pt-0">
        <div>
            <strong>{{ "Logistics" | t }}:</strong>
        </div>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Boxes in the base layer" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.boxes_in_base_layer ? activeProduct.boxes_in_base_layer : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Layers on the pallet" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.layers_on_pallet ? activeProduct.layers_on_pallet : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Boxes on the pallet" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.boxes_on_pallet ? activeProduct.boxes_on_pallet : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Pallet height (EU)" | t }} (mm)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.base_height | rn(1) }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "logistics-tab",
    mounted() {},
    computed: {
        ...mapState("ProductStore", ["activeProduct"])
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
